import { render, staticRenderFns } from "./ResetPasswordDlg.vue?vue&type=template&id=97c7f054&scoped=true"
import script from "./ResetPasswordDlg.vue?vue&type=script&lang=js"
export * from "./ResetPasswordDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c7f054",
  null
  
)

export default component.exports